import { useContext, useEffect, useState } from 'react';
import AccountPickerContext from '../contexts/AccountPickerContext';
import STORE from '../store';

export const ACTIVE_QUICK_FILTER_ID = 'ACTIVE_QUICK_FILTER';
export const CLOSED_QUICK_FILTER_ID = 'CLOSED_QUICK_FILTER';

// LegacySavedFilters is a shared Firestore collection used by several unrelated
// features (metric list items, report exports, legacy driver bonus pay summary
// items, and quick filters). Quick filter documents are isolated by the `source` field:
//   report quick filters    → "report: {reportId}"
//   dashboard quick filters → "dashboard: {dashboardId}"
//   board quick filters     → "{dataType} - board: {boardId}"
//   scorecard quick filters → "scorecard: {scorecardId}"
// The caller is responsible for passing the correct source string.
const useQuickFilters = (source: string) => {
  const [quickFilters, setQuickFilters] = useState<LegacySavedFilter[]>([]);
  const { selectedAccountId } = useContext(AccountPickerContext);

  useEffect(() => {
    const listener = STORE.filterDefinitions
      .getLegacySavedFiltersRef({
        accountId: selectedAccountId,
      })
      .where('source', '==', source)
      .onSnapshot((s) => {
        const data: LegacySavedFilter[] = [];
        s.docs.forEach((d) => data.push(d.data()));
        setQuickFilters([...data]);
      });
    return () => {
      listener();
    };
  }, [selectedAccountId, source]);

  return quickFilters;
};

export default useQuickFilters;
